import { SharedErrors } from 'web_core_library';
import { WorkoutTrial, WorkoutUnityResult } from 'web_unity_engine';

export interface IResult {
  timestamp: number;
  result: number;
}

export interface IBaseResult extends IResult {
  configVersion: number;
  configVariant: string;
  trainingId: number;
  sessionId: number;
  cycleId: number;
  workoutId: number;
  timestamp: number;
  localTs: number;
  result: number;
  gameHistory: string;
  startDifficulty: number;
  endDifficulty: number;
  meanDifficulty: number;
  minDifficulty: number;
  maxDifficulty: number;
  avgBadReactionTime: number;
  avgGoodReactionTime: number;
  trials?: WorkoutTrial[];
}

export interface ILocalResult extends IBaseResult {
  // timestamp of loading from backend or saving
  // means data was synchronized with backend
  syncTimestamp: number;
}

export interface ITrainingProgressResponse {
  filter: {
    uid: number;
    trainingid: number;
    limit?: number;
    workoutid?: number;
    page?: number;
    workoutids?: number[];
  };
  trainingprogress: IBaseResult[];
}

export interface IProgressCacheValue {
  // full progress of the user
  progress: ILocalResult[];
  // timestamp of the last progress entry
  // to detect if we need to fetch anything new
  timestamp: number;
}

export class ProgressError extends SharedErrors.BaseError {
  constructor(message: string) {
    super(message);
    Object.setPrototypeOf(this, ProgressError.prototype);
    this.feature = 'Progress';
  }
}

// Payload types
export interface IUpdateProgressPayload {
  progress: ILocalResult[];
  userId?: number;
}

export interface ISaveProgressPayload {
  variant: string;
  version: number;
  cycleId: number;
  sessionId: number;
  workoutId: number;
  progress: WorkoutUnityResult;
}

export interface ISaveProgressScorePayload {
  variant: string;
  version: number;
  cycleId: number;
  sessionId: number;
  workoutId: number;
  score: number;
}

export interface ILoadProgressHistoryPayload {
  startTimestamp: number;
  endTimestamp: number;
  userId?: number;
}

export interface IUpdateProgressHistoryPayload {
  startTimestamp: number;
  endTimestamp: number;
  progress: IBaseResult[];
  userId?: number;
}

export interface ILoadLastProgressPayload {
  workoutIds: number[];
  userId?: number;
}

export interface IUpdateWorkoutLastProgressPayload {
  workoutIds: number[];
  progress: IBaseResult[];
  userId?: number;
}

export interface ILoadworkoutProgressPayload {
  workoutIds: number[];
  userId?: number;
}

export interface IUpdateWorkoutProgressPayload {
  workoutId: number;
  progress: IBaseResult[];
  userId?: number;
}
